module.exports = __webpack_public_path__ + "static/media/7.6a9e893f.jpg";